import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import InfoDialog from "components/InfoDialog";
import {
  clearCampaignCreditPopup,
  formatCampaignCreditEuro,
  peekCampaignCreditPopup,
} from "utils/campaignCredit";

/** Shows a one-time dialog after a campaign promo credit was just granted. */
const CampaignCreditPopup = () => {
  const location = useLocation();
  const [payload, setPayload] = useState(null);

  useEffect(() => {
    const next = peekCampaignCreditPopup();
    if (next) setPayload(next);
  }, [location.pathname, location.search]);

  if (!payload) return null;

  const amount = formatCampaignCreditEuro(payload.creditCents);

  return (
    <InfoDialog
      open
      mark="€"
      title="Guthaben gutgeschrieben"
      message={`${amount} wurden deinem Konto gutgeschrieben. Du kannst sie bei deiner nächsten Buchung verwenden.`}
      confirmLabel="Weiter"
      onClose={() => {
        clearCampaignCreditPopup();
        setPayload(null);
      }}
    />
  );
};

export default CampaignCreditPopup;
